// extracted by mini-css-extract-plugin
export default {"root":"RestrictionPopOver-root_dkkBK"};